import {useClient, useMe} from '@/haligator-factory';
import {Outlet, ScrollRestoration} from 'react-router-dom';
import {ChargementCompte} from './ChargementCompte';
import {LivraisonsPossiblesContextProvider} from 'ff-common';
import {BreakpointProvider} from '@/chakra/BreakpointProvider';
import {SearchClientProvider, useClientAppDisplay} from 'ff-common';
import {SessionWarning} from './SessionWarning';
import NiceModal from '@ebay/nice-modal-react';
import {CompteBloque} from './CompteBloque';
import {ConversationsClientBoutonFlottant} from '../conversations/ConversationsClientBoutonFlottant';
import {useHalState} from '@synako/haligator';
import {SidePanelPanierProvider} from '@/components/SidePanelPanier/SidePanelPanierContext';
import {SearchProvider} from '@/components/Navbar/Searchbar/SearchContext';

/**
 * Wrapper pour afficher le bouton flottant des conversations si le feature flag est activé.
 */
const ConversationsBoutonFlottantWrapper: React.FC = () => {
  const meState = useHalState(useMe());
  const conversationsEnabled = meState.data?.conversations_enable;

  if (!conversationsEnabled) {
    return null;
  }

  return <ConversationsClientBoutonFlottant />;
};

export const ClientApp: React.FC = () => {
  const client = useClient();

  const clientApp = useClientAppDisplay(
    (prochaineLivraison) => (
      <LivraisonsPossiblesContextProvider initialLivraison={prochaineLivraison}>
        <SidePanelPanierProvider>
          {' '}
          {/* Pour le contrôle du side panel panier depuis n'importe quel composant enfant de ClientApp */}
          <SearchProvider>
            {' '}
            {/* Le contexte de recherche doit englober tout le contenu pour que la recherche puisse s'afficher par-dessus */}
            <NiceModal.Provider>
              {/* Message pour fin de session */}
              <SessionWarning />
              <Outlet />
              {/* Bouton flottant pour les conversations (conditionné par feature flag) */}
              <ConversationsBoutonFlottantWrapper />
            </NiceModal.Provider>
          </SearchProvider>
        </SidePanelPanierProvider>
      </LivraisonsPossiblesContextProvider>
    ),
    (idMessage: string) => <ChargementCompte idMessage={idMessage} />,
    () => <CompteBloque />,
    client,
  );

  return (
    <SearchClientProvider client={client}>
      <BreakpointProvider>
        <ScrollRestoration />
        {clientApp}
      </BreakpointProvider>
    </SearchClientProvider>
  );
};
